import { useCallback, useEffect, useState } from 'react';
import { downloadAdminModule, getAdminDownloads } from '../services/adminAuthService';

export const useAdminDownloads = () => {
  const [downloads, setDownloads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [activeDownload, setActiveDownload] = useState('');

  useEffect(() => {
    const load = async () => {
      const result = await getAdminDownloads();
      if (result.ok) setDownloads(result.data);
      else setError(result.error);
      setLoading(false);
    };
    load();
  }, []);

  const download = useCallback(async (item) => {
    setActiveDownload(item.id);
    setError('');
    const result = await downloadAdminModule(item);
    if (!result.ok) setError(result.error);
    setActiveDownload('');
  }, []);

  return { downloads, loading, error, activeDownload, download };
};
